import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { MyAccessRoleplayOutput } from '../domain/dtos/my-access-roleplay-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetMyAccess {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient<MyAccessRoleplayOutput>,
  ) {}

  public async execute(): Promise<MyAccessRoleplayOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/user/roleplay/my-access`,
    })

    if (response.statusCode === HttpStatusCode.OK && response?.data) {
      return response.data
    }

    throw new GeneralError()
  }
}
